'use es6';

import tinymce from 'tinymce';
import { getFetchAnchors, isAnchorNode } from '../utils/anchor';
import AnchorPopoverManager from '../components/AnchorPopoverManager';
import { __HS_ANCHOR } from '../constants/plugins';
import { CANVAS_ANCHOR } from '../constants/toolbar';
import { i18nKey } from '../constants/hsanchor';
import { addTransforms } from './transforms';
import { getAnchorClickHandler, getAnchorDragStartHandler, getAnchorDropHandler, getAnchorKeydownHandler, getToggleAnchorVisualAidHandler, getInsertAnchorHandler, getUpdateAnchorHandler, getInsertTempAnchorHandler, getRemoveTempAnchorsHandler, getAnchorRemoveHandler } from './handlers';
import { jsx as _jsx } from "react/jsx-runtime";
export const HS_ANCHOR = __HS_ANCHOR;
function addControls(editor, configProps) {
  tinymce.canvas.addMenuItem(editor, CANVAS_ANCHOR, {
    text: i18nKey('menuItem'),
    onClick: getAnchorClickHandler(editor)
  });
  const isActiveNodeHandler = ({
    element
  }) => {
    if (!element) return false;
    return isAnchorNode(element) && element;
  };
  tinymce.canvas.addNodeChangeHandler(editor, {
    eventKey: HS_ANCHOR,
    isActiveNodeHandler
  });
  tinymce.canvas.addPopover(editor, HS_ANCHOR, {
    renderPopover(renderProps) {
      return /*#__PURE__*/_jsx(AnchorPopoverManager, Object.assign({}, configProps, {
        editor: editor,
        onInsert: getInsertAnchorHandler(editor),
        onUpdate: getUpdateAnchorHandler(editor),
        onAnchorRemove: getAnchorRemoveHandler(editor),
        insertTempAnchor: getInsertTempAnchorHandler(editor),
        removeTempAnchors: getRemoveTempAnchorsHandler(editor),
        eventKey: HS_ANCHOR
      }, renderProps));
    }
  });
}
function hsAnchorPlugin(editor) {
  editor.on('dragStart', getAnchorDragStartHandler());
  editor.on('drop', getAnchorDropHandler(editor));
  editor.on('KeyDown', getAnchorKeydownHandler(editor));
  if (editor.settings.inline) {
    editor.on('focus', getToggleAnchorVisualAidHandler(editor, true));
    editor.on('blur', getToggleAnchorVisualAidHandler(editor, false));
  }
  addControls(editor, {
    fetchAnchors: getFetchAnchors(editor)
  });
  addTransforms(editor);
}
tinymce.PluginManager.add(HS_ANCHOR, hsAnchorPlugin);